
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Outstaioncabservicenavimumbai() {



const cardData = {
  keyword: "Outstation Cab Service Navi Mumbai",
  heading: "Skyline Cabs: Outstation Cab Service Navi Mumbai",
  headingDescription: "Skyline Cabs provides premium Outstation Cab Service Navi Mumbai for long-distance travel across Maharashtra and neighboring states. Whether you are planning a weekend getaway, spiritual pilgrimage, corporate visit, family vacation, or airport-connected outstation trip, we offer safe, comfortable, and professionally managed cab services. Our fleet includes well-maintained AC sedans, SUVs, and premium vehicles suitable for highway journeys. With experienced chauffeurs, transparent fare structure, and flexible one-way and round-trip options, Skyline Cabs ensures smooth and stress-free intercity travel from Navi Mumbai.",

  top: "Top Outstation Destinations from Navi Mumbai",

  topPlaces: [
    {
      title: "Lonavala",
      description: "Lonavala is one of the most preferred weekend destinations from Navi Mumbai, famous for its scenic hills, waterfalls, Tiger Point, Lion’s Point, and Bhushi Dam. Travelers often book Outstation Cab Service Navi Mumbai for comfortable highway travel through the expressway. The pleasant weather, especially during monsoon and winter seasons, makes it an ideal relaxation spot. Families, couples, and corporate groups enjoy day trips and overnight stays here. With Skyline Cabs, customers benefit from flexible return timing, safe ghat driving, and smooth intercity connectivity."
    },
    {
      title: "Shirdi",
      description: "Shirdi, the spiritual town of Sai Baba, attracts thousands of devotees every day. Many pilgrims book Navi Mumbai Outstation Taxi for early morning darshan and same-day return trips. The well-maintained highway route ensures comfortable long-distance travel. Skyline Cabs provides patient waiting time, experienced drivers, and clean vehicles suitable for senior citizens and family groups."
    },
    {
      title: "Pune",
      description: "Pune is a major educational and business hub frequently visited for corporate meetings, IT park visits, and tourism. Outstation Taxi Service from Navi Mumbai is ideal for same-day business return trips or weekend leisure travel. With Skyline Cabs, travelers enjoy punctual pickup, smooth expressway driving, and professional chauffeur support."
    },
    {
      title: "Mahabaleshwar",
      description: "Mahabaleshwar is a beautiful hill station known for strawberry farms, scenic viewpoints, and cool climate. Many customers Book Outstation Cab Navi Mumbai for relaxed family travel. The long ghat journey becomes safe and comfortable with experienced Skyline drivers."
    },
    {
      title: "Nashik",
      description: "Nashik is famous for Trimbakeshwar Temple, vineyards, and religious tourism. AC Outstation Cab Navi Mumbai provides smooth connectivity for spiritual and leisure trips. Skyline Cabs ensures comfortable return planning with flexible schedule options."
    }
  ],

  services: [
    {
      name: "cab hire in navi mumbai",
      description: "Skyline Cabs offers professional cab hire in navi mumbai for local and outstation travel needs. Whether planning business meetings, family visits, airport transfers, or weekend trips, our well-maintained vehicles ensure comfort and reliability. Our drivers are experienced in highway and city routes, providing smooth navigation and safe driving. Customers can choose flexible hourly, daily, or multi-day rental packages. Transparent pricing and clear fare breakdown make our cab hire service dependable and stress-free."
    },
    {
      name: "Outstation Cab Service Navi Mumbai",
      description: "Our Outstation Cab Service Navi Mumbai is designed for long-distance travel across Maharashtra and nearby states. We provide clean AC vehicles, trained chauffeurs, and structured trip planning for one-way and round-trip journeys. Ideal for family vacations, pilgrimage tours, and business travel, this service ensures safety and comfort throughout highway journeys."
    },
    {
      name: "Navi Mumbai Outstation Taxi",
      description: "Navi Mumbai Outstation Taxi offers reliable intercity transportation with flexible scheduling and experienced drivers. Customers enjoy comfortable seating, sufficient luggage space, and smooth expressway travel. Skyline Cabs ensures timely pickups and return coordination."
    },
    {
      name: "Outstation Taxi Service from Navi Mumbai",
      description: "Outstation Taxi Service from Navi Mumbai includes personalized travel planning for corporate, leisure, and spiritual trips. Our fleet supports long-distance journeys with air-conditioned comfort and highway-ready performance."
    },
    {
      name: "Book Outstation Cab Navi Mumbai",
      description: "Book Outstation Cab Navi Mumbai easily through our online platform with instant confirmation and secure payment options. Flexible departure timing and transparent pricing make booking convenient."
    },
    {
      name: "Best Outstation Cab Service Navi Mumbai",
      description: "Recognized as Best Outstation Cab Service Navi Mumbai, Skyline Cabs focuses on punctuality, vehicle quality, and customer satisfaction for every long-distance journey."
    },
    {
      name: "AC Outstation Cab Navi Mumbai",
      description: "AC Outstation Cab Navi Mumbai ensures climate-controlled comfort during long highway travel. Clean interiors and professional chauffeurs enhance overall travel experience."
    },
    {
      name: "Private Outstation Taxi Navi Mumbai",
      description: "Private Outstation Taxi Navi Mumbai offers exclusive vehicle usage for privacy, comfort, and flexible travel planning without shared passengers."
    },
    {
      name: "Affordable Outstation Cab Navi Mumbai",
      description: "Affordable Outstation Cab Navi Mumbai provides competitive fare packages suitable for families and business travelers without compromising service quality."
    },
    {
      name: "Reliable Outstation Taxi from Navi Mumbai",
      description: "Reliable Outstation Taxi from Navi Mumbai ensures safe highway driving, transparent pricing, and professional trip coordination for stress-free travel."
    }
  ],

  tableData: [
    ["cab hire in navi mumbai", "Outstation Cab Service Navi Mumbai"],
    ["Navi Mumbai Outstation Taxi", "Outstation Taxi Service from Navi Mumbai"],
    ["Book Outstation Cab Navi Mumbai", "Best Outstation Cab Service Navi Mumbai"],
    ["AC Outstation Cab Navi Mumbai", "Private Outstation Taxi Navi Mumbai"],
    ["Affordable Outstation Cab Navi Mumbai", "Reliable Outstation Taxi from Navi Mumbai"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Highway Travel Expertise",
      WhyChoosedescription: "Our drivers are trained for long-distance highway driving, ensuring safe navigation through expressways and ghat sections."
    },
    {
      WhyChooseheading: "Transparent Pricing Policy",
      WhyChoosedescription: "Clear fare structure with no hidden costs ensures budget-friendly outstation travel."
    },
    {
      WhyChooseheading: "Comfortable AC Vehicles",
      WhyChoosedescription: "Well-maintained air-conditioned cars suitable for extended journeys."
    },
    {
      WhyChooseheading: "Flexible Travel Packages",
      WhyChoosedescription: "One-way, round-trip, and multi-day travel options available."
    },
    {
      WhyChooseheading: "24x7 Booking Support",
      WhyChoosedescription: "Round-the-clock customer assistance for urgent travel requirements."
    },
    {
      WhyChooseheading: "Private & Secure Travel",
      WhyChoosedescription: "Exclusive vehicle usage for families and corporate clients."
    },
    {
      WhyChooseheading: "Professional Chauffeurs",
      WhyChoosedescription: "Experienced and verified drivers ensure punctual and safe travel."
    },
    {
      WhyChooseheading: "Customer Satisfaction Focus",
      WhyChoosedescription: "Dedicated support team ensures smooth trip planning and execution."
    }
  ]
}


const faqData = [
    {
        id: 1,
        question: 'How can I book Outstation Cab Service Navi Mumbai with Skyline Cabs?',
        answer:
            'Booking Outstation Cab Service Navi Mumbai with Skyline Cabs is simple and convenient. You can visit our website or mobile app, enter your pickup location in Navi Mumbai and your outstation destination, choose your preferred vehicle, and confirm instantly. Once booked, you receive driver details and trip confirmation for complete transparency. Our booking process is quick, secure, and designed for stress-free travel planning.',
    },
    {
        id: 2,
        question: 'Which destinations are covered under Outstation Cab Service Navi Mumbai?',
        answer:
            'Skyline Cabs provides Outstation Cab Service Navi Mumbai to popular destinations such as Pune, Lonavala, Mahabaleshwar, Shirdi, Nashik, Kolhapur, Goa, and many more. Whether you are planning a weekend getaway, business trip, pilgrimage, or family vacation, we offer reliable and comfortable long-distance cab services across Maharashtra and nearby states.',
    },
    {
        id: 3,
        question: 'What vehicle options are available for Outstation Cab Service Navi Mumbai?',
        answer:
            'We offer multiple vehicle options including Swift Dzire, Ertiga, Innova Crysta, and premium SUVs for Outstation Cab Service Navi Mumbai. You can select economical sedans for budget travel or spacious SUVs for family and group trips. All vehicles are well-maintained, sanitized, and driven by professional chauffeurs experienced in highway travel.',
    },
    {
        id: 4,
        question: 'Is one-way Outstation Cab Service Navi Mumbai available?',
        answer:
            'Yes, Skyline Cabs offers affordable one-way Outstation Cab Service Navi Mumbai. You only pay for the distance traveled without unnecessary return charges, making it cost-effective for single-direction travel. It is ideal for airport transfers, business trips, or relocation travel.',
    },
    {
        id: 5,
        question: 'Is the fare for Outstation Cab Service Navi Mumbai fixed and transparent?',
        answer:
            'Yes, Skyline Cabs follows a transparent and fixed pricing model for Outstation Cab Service Navi Mumbai. The fare is shared before booking confirmation and includes driver allowance and applicable charges. There are no hidden fees, ensuring complete pricing clarity and customer trust.',
    },
    {
        id: 6,
        question: 'How safe is Outstation Cab Service Navi Mumbai?',
        answer:
            'Safety is our top priority. Our Outstation Cab Service Navi Mumbai includes experienced drivers, well-maintained vehicles, and regular safety checks. We ensure smooth highway travel and professional driving standards for a secure and comfortable journey.',
    },
    {
        id: 7,
        question: 'Can I pre-book Outstation Cab Service Navi Mumbai?',
        answer:
            'Yes, you can pre-book your Outstation Cab Service Navi Mumbai for weekends, holidays, corporate travel, or special occasions. Advance booking ensures vehicle availability and better travel planning, especially during peak seasons.',
    },
    {
        id: 8,
        question: 'Is online payment available for Outstation Cab Service Navi Mumbai?',
        answer:
            'Yes, Skyline Cabs supports secure online payments including UPI, credit cards, debit cards, and net banking. Once payment is completed, you receive instant booking confirmation along with trip and driver details.',
    },
    {
        id: 9,
        question: 'Is Outstation Cab Service Navi Mumbai suitable for family trips?',
        answer:
            'Absolutely. Our Outstation Cab Service Navi Mumbai is ideal for family travel and group trips. Spacious vehicles, comfortable seating, powerful AC, and ample luggage space ensure a relaxed and enjoyable long-distance journey.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Outstation Cab Service Navi Mumbai?',
        answer:
            'Skyline Cabs is trusted for Outstation Cab Service Navi Mumbai because of our professional chauffeurs, clean and comfortable vehicles, transparent pricing, punctual service, and 24x7 customer support. We focus on delivering reliable, safe, and stress-free outstation travel experiences every time.',
    },
];

const someReviews = [
    {
        name: "Mr. Kiran Deshmukh",
        rating: 5,
        review: "Booked Outstation Cab Service Navi Mumbai with Skyline Cabs for a family trip to Mahabaleshwar. The car was comfortable, driver was professional, and the entire journey was smooth. Highly satisfied with the service!"
    },
    {
        name: "Mrs. Neeta Sharma",
        rating: 4,
        review: "Very reliable Outstation Cab Service Navi Mumbai. Transparent pricing, clean vehicle, and punctual pickup. Skyline Cabs made our trip stress-free and comfortable."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      
    
      
const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Outstation Cab Service Navi Mumbai",
  "image": "https://skylinecabs.com/assets/images/outstation-cab-navi-mumbai.jpg",
  "description": "Book Outstation Cab Service from Navi Mumbai with Skyline Cabs for comfortable, reliable, and affordable long-distance travel. AC and private cabs available 24x7 with professional drivers for one way and round trips across Maharashtra.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2999",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/outstation-cab-service-navi-mumbai"
  }
};



    return (
        <div>

<Helmet>
  <title>Outstation Cab Service Navi Mumbai | AC & Private Long-Distance Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Outstation Cab Service from Navi Mumbai with Skyline Cabs for reliable, comfortable, and affordable long-distance travel. AC and private cabs available 24x7 for one way and round trips with professional drivers." 
  />
  <meta 
    name="keywords" 
    content="cab hire in navi mumbai, Outstation Cab Service Navi Mumbai, Navi Mumbai Outstation Taxi, Outstation Taxi Service from Navi Mumbai, Book Outstation Cab Navi Mumbai, Best Outstation Cab Service Navi Mumbai, AC Outstation Cab Navi Mumbai, Private Outstation Taxi Navi Mumbai, Affordable Outstation Cab Navi Mumbai, Reliable Outstation Taxi from Navi Mumbai, 24x7 Outstation Cab Service Navi Mumbai, Outstation Cab Navi Mumbai Fare, Navi Mumbai Outstation Taxi Charges, Cheapest Outstation Cab in Navi Mumbai, Outstation Cab Booking Navi Mumbai, Navi Mumbai Outstation Cab Price, Innova Crysta Outstation Cab Navi Mumbai, Skyline Cabs Outstation Navi Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/134.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Outstaioncabservicenavimumbai;